<template>
	<v-container fluid class="px-0" id="listado-consultas">

		<v-card class="mb-2 py-1 listing-header-card">
			<v-card-text class="header-table-card py-2">
				<v-row>
					<v-col cols="10">
					<v-menu offset-y v-model="filtersMenu">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									rounded
									color="#2D4B95"
									dark
									small
									block
									v-bind="attrs"
									v-on="on"
								>
									Filtros
								</v-btn>
							</template>
							<v-list>
								<v-list-item>
									<v-btn class="custom-button-consultas flex-row align-center justify-space-between"
										block
										@click="toggleOrder">
										<p class="mb-0 font-weight-bold body-2 text-capitalize">
											{{getNameOrder()}}</p>
										<v-icon color="#5e85ef" small>{{getIconOrder()}}</v-icon>
									</v-btn>
								</v-list-item>
								<v-list-item>
									<FilterMenu
										v-model="creatorFilter"
										:items="$store.consultasStore.state.taskCreators"
										label="Creador"
										:itemValue="'id'"
										:itemText="'name'"
										:searchEnabled="true"
										searchPlaceholder="Buscar creador..."
										:maxHeight="300"
										:activatorStyle="{'height':'36px'}"
										activatorClass="custom-button-consultas elevation-2 flex-row align-center justify-space-between"
										@apply="filterList"
									/>
								</v-list-item>
								<v-list-item>
									<FilterMenu
										v-model="responsableFilter"
										:items="$store.consultasStore.state.taskResponsables"
										label="Responsable"
										:itemValue="'id'"
										:itemText="'name'"
										:searchEnabled="true"
										searchPlaceholder="Buscar responsable..."
										:maxHeight="300"
										:activatorText="false"
										:activatorStyle="{'height':'36px'}"
										activatorClass="custom-button-consultas flex-row align-center elevation-2 justify-space-between"
										@apply="filterList"
									/>
								</v-list-item>
								<v-list-item>
									<FilterMenu
										v-model="codeFilter"
										:items="$store.consultasStore.state.taskFilterCodes"
										label="Tarea"
										:itemValue="'id'"
										:itemText="(code) => `${code.sku} - ${code.specialties}`"
										:searchEnabled="true"
										searchPlaceholder="Buscar tarea..."
										:maxHeight="400"
										:activatorText="false"
										:activatorStyle="{'height':'36px'}"
										activatorClass="custom-button-consultas elevation-2 flex-row align-center justify-space-between"
										@apply="filterList"
									/>
								</v-list-item>
							</v-list>
						</v-menu>
					</v-col>
					<v-col cols="2" class="d-flex flex-row justify-end align-center py-0 icon-container">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<div class="icon-top total"
									v-bind="attrs"
									v-on="on">
									<span class="white--text caption">{{$store.consultasStore.state.listadoTareas.total_tasks}}</span>
								</div>
							</template>
							<span>Total de tareas</span>
						</v-tooltip>
					</v-col>
				</v-row>
				<div class="d-flex align-center justify-end flex-wrap mt-2" style="gap: 10px;">
					<v-btn dark x-small color="#2D4B95" :loading="loadingExport" :disabled="loadingExport" @click="excelExport()">
						<v-icon small class="mr-1">mdi-microsoft-excel</v-icon>
						<p class="mb-0">Exportar a Excel</p>
					</v-btn>
				</div>
			</v-card-text>
			<v-progress-linear
				v-if="$store.consultasStore.state.listadoTareas.status === 99"
				class="listing-loading-bar"
				indeterminate
				color="#5e85ef"
			></v-progress-linear>
		</v-card>
		<div v-if="$store.consultasStore.state.listadoTareas.status === 1 || $store.consultasStore.state.listadoTareas.count > 0" class="listing-scroll">
			<v-card class="tarea-card mb-2" v-for="(tarea, index) in $store.consultasStore.state.listadoTareas.data" :key="index"
			style="overflow: hidden;"
			@click.stop="viewTarea(tarea.id, $options.filters.seenByMe(tarea.seen_by_me))">
				<v-tooltip bottom
							v-if="tarea.private">
					<template v-slot:activator="{ on, attrs }">
						<div class="incognito-container"
							v-bind="attrs"
							v-on="on">
							<v-icon color="white" small>mdi-incognito</v-icon>
						</div>
					</template>
					<span>Tarea privada: sólo la puedes ver tú y el responsable</span>
				</v-tooltip>
				<v-card-text class="header-table-card py-2"
					:class="tarea.status === 3 ? 'status-ended':''">
					<v-row align="center">
						<v-col cols="4" sm="2">
							<div class="d-flex flex-column">
								<div v-if="tarea.status === 3">
									<v-chip
										class="mb-1"
										color="#34BFA3"
										text-color="white"
										x-small
									>
										Finalizada
									</v-chip>
								</div>
								<div class="d-flex flex-row icon-container">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<div class="icon-top number"
												v-bind="attrs"
												v-on="on">
												<p class="mb-0 white--text text-task-number caption">{{tarea.number}}</p>
											</div>
										</template>
										<span>Tarea número {{tarea.number}}</span>
									</v-tooltip>
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-icon color="white"
												class="icon-top"
												v-bind="attrs"
												v-on="on"
												:class="getTareaPriorityColor(tarea)" small>mdi-exclamation</v-icon>
										</template>
										<span>Prioridad {{getTareaPriorityText(tarea)}}</span>
									</v-tooltip>
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<div class="icon-top d-flex justify-center align-center" :class="$options.filters.seenByMeColor(tarea.seen_by_me)"
												v-bind="attrs"
												v-on="on"
												v-if="canISeeBell(tarea)"
												@click.stop="changeVisualizationStatus(tarea)">
												<v-icon color="white"
													:class="$options.filters.seenByMeIconAnimation(tarea.seen_by_me)"
													v-if="!isLoadingChangeVisualizationStatus(tarea.id)"
													small>mdi-bell</v-icon>
												<v-progress-circular
													v-else
													:width="2"
													:size="16"
													color="white"
													indeterminate
												></v-progress-circular>
											</div>
										</template>
										<span>{{$options.filters.seenByMeText(tarea.seen_by_me)}}</span>
									</v-tooltip>
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-icon color="white"
												class="icon-top"
												:class="!tarea.seen ? 'high':'success'"
												v-bind="attrs"
												v-on="on"
												small>mdi-check</v-icon>
										</template>
										<span>El responsable {{!tarea.seen ? 'no':''}} ha visualizado esta tarea</span>
									</v-tooltip>
								</div>
							</div>
						</v-col>
						<v-col cols="8" sm="2">
							<div class="status-container d-flex flex-row align-center">
								<v-tooltip bottom v-if="checkIfNearDeadline(tarea)">
									<template v-slot:activator="{ on, attrs }">
										<v-icon color="white"
											class="icon-status icon-top medium"
											v-bind="attrs"
											v-on="on"
											small v-if="!tarea.seen">mdi-flag-outline</v-icon>
									</template>
									<span>Se acerca la fecha crítica {{tarea.critical_date | toDate}}</span>
								</v-tooltip>
								<v-img :src="setLights(tarea.lightstatus)"
									max-height="50"
									max-width="35"
									contain
									class="mr-1"/>
								<div class="d-flex flex-column flex-grow-1">
									<p class="mb-0 body-2 text--secondary caption">Espera: {{ tarea.waitingtime }}</p>
									<p class="mb-0 font-weight-bold caption text-primary-color d-flex flex-row">
										<small>{{tarea.created_at | toDate}}</small>

										<v-tooltip bottom v-if="tarea.critical_date">
											<template v-slot:activator="{ on, attrs }">
												<div class="d-flex flex-row critical-date-container px-1 mx-1 rounded"
													v-bind="attrs"
													v-on="on">
													<v-icon x-small color="white" class="mr-1">mdi-calendar-range-outline</v-icon>
													<p class="mb-0 white--text caption font-weight-bold"><small>{{tarea.critical_date | toDate}}</small></p>
												</div>
											</template>
											<span>Fecha crítica: {{tarea.critical_date | toDate}}</span>
										</v-tooltip>
									</p>
								</div>
								<!-- <v-btn rounded color="#5e85ef" dark small @click="viewTarea(tarea.id, tarea.seen_by_me)">
									<p class="mb-0 font-weight-bold body-2 text-capitalize">Ver Consulta</p>
								</v-btn> -->
							</div>
						</v-col>
						<v-col cols="6" sm="2" align-self="start">
							<div>
								<div class="d-flex flex-row align-center">
									<div>
										<p class="mb-0 light-blue-text caption">Creador</p>
										<p class="mb-0 body-2 text--secondary">
											{{tarea.created_by_user.name}}
										</p>
									</div>

									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-icon color="#5e85ef" small
												class="ml-1"
												v-bind="attrs"
												v-on="on"
												v-if="tarea.created_by_user.id === $store.userStore.state.userInfo.id">mdi-account</v-icon>
										</template>
										<span>Tú creaste esta tarea</span>
									</v-tooltip>
								</div>
								<p class="mb-0 font-weight-bold body-2 light-blue-text">{{tarea?.userjob?.userjobtype?.name || ''}}</p>
							</div>
						</v-col>
						<v-divider vertical></v-divider>
						<v-col cols="6" sm="2" align-self="start">
							<div>
								<div class="d-flex flex-row align-center">
									<p class="mb-0 light-blue-text caption">Responsable</p>
									<div class="ml-2" v-if="checkPermissions(['change_responsable_task'])" @click.stop>
										<FilterMenu
											:value="quickResponsableSelection[tarea.id] || []"
											@input="setQuickResponsableSelection(tarea.id, $event)"
											:items="getResponsableOptions(tarea)"
											label="Responsable"
											:listTitle="'Cambiar Responsable'"
											:itemValue="'id'"
											:itemText="(user) => `${user.name} - ${user?.projectjob?.userjobtype?.name || ''}`"
											:searchEnabled="true"
											searchPlaceholder="Buscar usuario..."
											:maxHeight="300"
											:multiple="false"
											:showCheckbox="false"
											:showLabel="false"
											:activatorText="false"
											:activatorBlock="false"
											activatorIcon="mdi-swap-horizontal-bold"
											:activatorStyle="{height:'24px', width:'24px', minWidth:'24px', padding:'0'}"
											activatorClass="inline-change-btn elevation-0"
											:activatorLoading="isChangingResponsable(tarea.id)"
											:activatorDisabled="isChangingResponsable(tarea.id)"
											@activator-click="checkUsers(tarea)"
											@apply="quickChangeResponsableFromFilter(tarea)"
										/>
									</div>
								</div>
								<p class="mb-0 body-2 text--secondary">{{tarea.responsable_user.name}}</p>
								<p class="mb-0 font-weight-bold body-2 light-blue-text">{{tarea?.responsablejob?.userjobtype?.name || ''}}</p>
							</div>
						</v-col>
						<v-col cols="12" sm="4" class="pt-0">
							<div class="d-flex flex-column justify-center align-center">
								<p class="inner-text light-blue-text mb-0" style="width: 100%;" v-if="tarea.code">{{tarea.code.sku}} - {{tarea.code.specialties}}</p>
								<p class="mb-0 font-weight-bold body-2 text-primary-color" style="width: 100%;">{{tarea.title}}</p>
								<div class="mb-0 caption body-2 text--secondary text-tarea-field" style="width: 100%;" v-html="tarea.description"></div>
							</div>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
			<v-row align="center">
				<v-col cols="12">
					<v-pagination
						v-model="listPage"
						color="#2D4B95"
						:length="Math.ceil($store.consultasStore.state.listadoTareasTotal/50)"
						:total-visible="7"
						@input="changePage"
					></v-pagination>
				</v-col>
			</v-row>
		</div>
		<div v-else>
			<v-card class="mb-2 py-2" v-for="i in 5" :key="i">
				<v-card-text class="py-2">
					<v-row>
						<v-col cols="1">
							<div class="d-flex flex-row">
								<v-skeleton-loader class="mx-auto" min-width="100%" type="list-item" ></v-skeleton-loader>
							</div>
						</v-col>
						<v-col cols="2">
							<div>
								<v-skeleton-loader class="mx-auto" min-width="100%" type="list-item" ></v-skeleton-loader>
							</div>
						</v-col>
						<v-col cols="4">
							<div class="d-flex flex-row justify-center align-center">
								<v-skeleton-loader class="mx-auto" min-width="100%" type="list-item" ></v-skeleton-loader>
							</div>
						</v-col>
						<v-col cols="2">
							<div>
								<v-skeleton-loader class="mx-auto" min-width="100%" type="list-item" ></v-skeleton-loader>
							</div>
						</v-col>
						<v-col cols="3">
							<div>
								<v-skeleton-loader class="mx-auto" min-width="100%" type="list-item" ></v-skeleton-loader>
							</div>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</div>
		
	</v-container>
</template>

<script>
import moment from 'moment'
import {getTareaByID, changeVisualizationStatus, changeResponsable} from '@/helpers/api/tasks'
import {exportTasksByProject} from '@/helpers/api/exports'
import FilterMenu from '@/components/Globals/Helpers/FilterMenu.vue'

export default {
	name: 'ListadoConsultasContainer',
	components: {FilterMenu},
	props: {
		ended:{
			type: Boolean,
			default: false
		}
	},
	computed: {
		searchTaskFilter() {
			return this.$store.consultasStore.state.searchFilter
		},
		creatorFilter: {
			get() { return this.$store.consultasStore.state.creatorFilter },
			set(value) { this.$store.consultasStore.commit('setCreatorFilter', value) }
		},
		responsableFilter: {
			get() { return this.$store.consultasStore.state.responsableFilter },
			set(value) { this.$store.consultasStore.commit('setResponsableFilter', value) }
		},
		codeFilter: {
			get() { return this.$store.consultasStore.state.codeFilter },
			set(value) { this.$store.consultasStore.commit('setCodeFilter', value) }
		},
		listPage: {
			get() {
				const selectedType = this.$store.consultasStore.state.selectedType
				return this.$store.consultasStore.state.listadoTareasPages[selectedType] || 1
			},
			set(value) {
				const selectedType = this.$store.consultasStore.state.selectedType
				this.$store.consultasStore.commit('setListadoTareasPage', {type: selectedType, page: value})
			}
		}
	},
	watch: {
		searchTaskFilter(newData, oldData) {
			if(newData != oldData || oldData && !newData){
				this.getConsultasList()
			}
		}
	},
	data: () => ({
		filtersMenu: false,
		changingResponsableTasks: [],
		quickResponsableSelection: {},
		loadingExport: false,
	}),
	mounted(){},
	methods: {
		canISeeBell(tarea){
			if( !(this.$store.userStore.state.userInfo.id == tarea.responsable || this.$store.userStore.state.userInfo.id == tarea.created_by) &&
					(
						this.$store.projectsStore.state.selectedProject.job_type.id == 3 ||
						this.$store.projectsStore.state.selectedProject.job_type.id == 4 ||
						this.$store.projectsStore.state.selectedProject.job_type.id == 6
					)
				){
				return false
			}
			return true
		},
		async changeVisualizationStatus(task){
			if(!this.isLoadingChangeVisualizationStatus(task.id)){
				let newStatus = 0
				if(!task.seen_by_me){
					newStatus = 1
				}
				else if(task.seen_by_me.seen_status < 2){
					newStatus = task.seen_by_me.seen_status + 1
				}
				else if(task.seen_by_me.seen_status === 2){
					newStatus = 0
				}

				this.$store.consultasStore.commit('addLoadingChangeVisualizationStatus', task.id)
				const data = {
					task_id: task.id,
					status: newStatus
				}
				const statusUpdate = await changeVisualizationStatus(data)
				if(statusUpdate.code === 200){
					// Actualizo el estado de forma local para no tener que pedir todo de nuevo a la api por cada actualización de estado
					let newTaskData = Object.assign({}, task)
					newTaskData.seen_by_me.seen_status = newStatus
					this.$store.consultasStore.dispatch('updateTaskLocally', newTaskData)
				}
				this.$store.consultasStore.commit('removeLoadingChangeVisualizationStatus', task.id)
			}
		},
		isLoadingChangeVisualizationStatus(taskID){
			const found = this.$store.consultasStore.state.loadingChangeVisualizationStatus.find((task_id) => task_id === taskID)
			return found
		},
		getIconOrder(){
			if(this.$store.consultasStore.state.listingOrder === 1 || this.$store.consultasStore.state.listingOrder === 3){
				return 'mdi-arrow-down-bold'
			}
			else if(this.$store.consultasStore.state.listingOrder === 2 || this.$store.consultasStore.state.listingOrder === 4){
				return 'mdi-arrow-up-bold'
			}
			return 'mdi-swap-vertical-bold'
		},
		toggleOrder(){
			this.$store.consultasStore.commit('setListingOrder')
			this.getConsultasList()
		},
		getNameOrder(){
			if(this.$store.consultasStore.state.listingOrder === 1 || this.$store.consultasStore.state.listingOrder === 2){
				return 'Prioridad'
			}
			else if(this.$store.consultasStore.state.listingOrder === 3 || this.$store.consultasStore.state.listingOrder === 4){
				return 'Número'
			}
		},
		clearFilters(){
			this.creatorFilter = []
			this.codeFilter = []
			this.responsableFilter = []
		},
		async getConsultasList(){
			let project_id = null
			const page = this.listPage
			if(this.$store.projectsStore.state.selectedProject){
				project_id = this.$store.projectsStore.state.selectedProject.id
			}
			else{
				const id = localStorage.getItem('selectedProjectID')
				project_id = parseInt(id)
			}
			if(project_id){
				this.$store.consultasStore.dispatch('getMyTasks',
					{
						project_id, page,
						filtered_creator_users: this.creatorFilter,
						filtered_resp_users: this.responsableFilter,
						filtered_code_ids: this.codeFilter,
						search: this.searchTaskFilter
					})
			}
		},
		getTareaPriorityColor(tarea){
			if(tarea.priority === 3){
				return 'high'
			}
			else if(tarea.priority === 2){
				return 'medium'
			}
			return 'normal'
		},
		getTareaPriorityText(tarea){
			if(tarea.priority === 3){
				return 'Inmediata'
			}
			else if(tarea.priority === 2){
				return 'Media'
			}
			return 'Estándar'
		},
		checkIfNearDeadline(tarea){
			if(!tarea.critical_date){ return false }
			const now = moment()
			const tarea_date = moment(tarea.critical_date)
			return tarea_date.diff(now, 'days') <= 2
		},
		setLights(data){
			return require('@/assets/Svg/VistaListado/Semaforo'+data+'.svg')
		},
		filterList(){
			this.getConsultasList()
			this.filtersMenu = false
		},
		checkUsers(tarea){
			if(!tarea || !tarea.project_id){
				return
			}
			const usersForItems = this.$store.usersStore.state.usersListForItems
			if(!this.$store.usersStore.state.loadingUserListForItems &&
					usersForItems.project_id !== tarea.project_id
				){
				this.getUserListforItems(tarea.project_id)
			}
		},
		getUserListforItems(projectID){
			const data = {
				project_id: projectID,
				start: 0,
				limit: 9999
			}
			this.$store.usersStore.dispatch('getUsersListForItems', data)
		},
		getResponsableOptions(tarea){
			const users = this.$store.usersStore.state.usersListForItems.users || []
			return users.filter((user) => tarea.responsable !== user.id)
		},
		setQuickResponsableSelection(taskID, value){
			this.$set(this.quickResponsableSelection, taskID, value || [])
		},
		isChangingResponsable(taskID){
			return this.changingResponsableTasks.includes(taskID)
		},
		async quickChangeResponsableFromFilter(tarea){
			const selection = this.quickResponsableSelection[tarea.id] || []
			const selectedUserID = selection[0]
			if(!selectedUserID){
				return
			}
			await this.quickChangeResponsable(tarea, selectedUserID)
			this.setQuickResponsableSelection(tarea.id, [])
		},
		async quickChangeResponsable(tarea, userID){
			if(!tarea || !userID || tarea.responsable === userID || this.isChangingResponsable(tarea.id)){
				return
			}
			this.changingResponsableTasks.push(tarea.id)
			const taskUpdate = await changeResponsable({
				task_id: tarea.id,
				user_id: userID
			})
			if(taskUpdate.code === 200 && taskUpdate.task){
				this.$store.consultasStore.dispatch('updateTaskLocally', taskUpdate.task)
				this.$store.projectsStore.dispatch('getDashboardInfo')
				this.getConsultasList()
			}
			this.changingResponsableTasks = this.changingResponsableTasks.filter((id) => id !== tarea.id)
		},
		async viewTarea(task_id, seen_by_me){
			this.$store.consultasStore.commit('setCurrentTarea', {loading: true})
			const tarea = await getTareaByID({task_id})
			if(tarea.code === 200){
				let tareaData = tarea.task
				tareaData.prev_seen_by_me = seen_by_me
				this.$store.consultasStore.commit('setCurrentTarea', tareaData)
			}
		},
		changePage(){
			this.getConsultasList()
		},
		async excelExport(){
			this.loadingExport = true
			const data = {
				project_id: this.$store.projectsStore.state.selectedProject.id
			}
			const exportConsultas = await exportTasksByProject(data)
			if(exportConsultas.code == 200){ window.open(exportConsultas.url) }
			this.loadingExport = false
		}
	}
};
</script>

<style scoped>
	#listado-consultas{align-self: stretch;}
	.text-primary-color{
		color: #2D4B95;
	}
	.light-blue-text{color: #5E85EF;}
	.inner-text{
		font-size: 10px;
	}
	.status-container{
		position: relative;
	}
	.icon-top.icon-status{
		position: absolute;
		width: 20px;
		height: 20px;
		left: -20px;
	}
	.icon-top{
		padding: 2px;
		margin: 0 2px;
		border-radius: 100%;
	}
	.icon-top.high{
		background-color: #F4516C;
	}
	.icon-top.medium{
		background-color: #fb8c00;
	}
	.icon-top.normal{
		background-color: #3EBFA3;
	}
	.icon-top.primary{
		background-color: #2D4B95;
	}
	.icon-top.light-blue{
		background-color: #5E85EF;
	}
	.counter-tareas{
		background-color: #F4516C;
		border-radius: 100%;
		padding: 5px;
		width: 30px;
		height: 30px;
		line-height: 20px;
		color: white;
		font-size: 20px;
		text-align: center;
	}
	.status-icon{
		border: 1px solid #5e85ef;
		border-radius: 100%;
	}
	/deep/ .status-icon .inner{
		border: 1px solid #f2f2f2;
		border-radius: 100%;
		width: 14px;
		height: 14px;
	}
	/deep/ .status-icon .inner.danger{
		background-color: #F4516C;
	}
	/deep/ .header-table-card .table-header-button:hover:before{
		opacity: 0;
	}
	.text-tarea-field{
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 1; /* number of lines to show */
		-webkit-box-orient: vertical;
		max-height: 20px;
	}
	/deep/ .text-tarea-field h1,/deep/ .text-tarea-field h2,/deep/ .text-tarea-field h3{
		font-size: 1em!important;
	}
	.icon-container{flex-wrap: wrap;}
	.icon-container .icon-top{
		flex: 1 0 30%;
		width: 24px;
		max-width: 24px;
		height: 24px;
		max-height: 24px;
		margin-bottom: 2px;
	}
	.icon-container .icon-top.number{
		background-color: #2D4B95;
		text-align: center;
		line-height: 20px;
		width: 35px;
		max-width: 35px;
		border-radius: 5px;
	}
	.text-task-number.caption{ font-size: 10px!important; }
	.icon-container .icon-top.total{
		background-color: #5E85EF;
		text-align: center;
		line-height: 20px;
	}
	.critical-date-container{
		background-color: #5E85EF;
	}
	.listing-loading-bar{
		position: absolute;
		bottom: 0;
	}
	.header-table-card{
		border: 1px solid white;
	}
	.listing-header-card{
		position: sticky;
		top: 0;
		z-index: 1;
		background: white;
	}
	.status-ended{
		border: 1px solid #4caf50;
	}
	/deep/ .inline-change-btn.v-btn{
		border-radius: 50%;
	}
	/deep/ .inline-change-btn.v-btn .v-icon{
		color: #5E85EF !important;
	}
/*	.listing-scroll{
		overflow-y: scroll;
		height: 100%;
	}*/
	.tarea-card{
		position: relative;
	}
	.incognito-container{
		width: 0;
		height: 0;
		border-top: 33px solid #616161;
		border-right: 33px solid transparent;
		border-radius: 0!important;
		position: absolute;
		left: 0px;
	}
	.incognito-container .v-icon{
		position: absolute;
		top: -32px;
		left: 1px;
	}
	.custom-button-consultas.v-btn{
		background-color: white;
		color: #2D4B95;
		opacity: 1!important;
	}
	/deep/ .custom-button-consultas.v-btn .v-icon,
	/deep/ .custom-button-consultas.v-btn p{
		color: #2D4B95!important;
		font-size: 13px;
	}
	/deep/ .custom-button-consultas.v-btn .v-icon{font-size: 20px;}
	/deep/ .custom-button-consultas.v-btn:hover .v-icon,
	/deep/ .custom-button-consultas.v-btn:hover p,
	/deep/ .custom-button-consultas.v-btn.selected .v-icon,
	/deep/ .custom-button-consultas.v-btn.selected p{
		color: white!important;;
	}
	.custom-button-consultas.selected,
	.custom-button-consultas:hover{
		background-color: #2D4B95!important
	}
</style>
